<h1 mat-dialog-title>
    <app-titulo-paginas titulo="Medição (Capa de Lote)"></app-titulo-paginas>
  </h1>
  <mat-dialog-content>
    <div class="col-lg-12">
      <div class="alert alert-info">
        <div class="card-header">
          <span class="fas fa-user"></span><strong> Paciente:
          </strong>{{ data?.contract?.paciente?.pessoa?.nome | titlecase }}
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-4">
          <label for="profissional">Profissional:</label>
          <p>{{data?.profissional?.pessoa?.nome}}</p>
        </div>
        <div class="col-md-4">
          <label for="dataSolicitacao">Data de Solicitação:</label>
          <p>{{data?.dataSolicitacao | date: "dd/MM/yyyy"}}</p>
        </div>
        <div class="col-md-4">
          <label for="numeroGuiaPrestador">Número Guia Prestador:</label>
          <p>{{data?.numeroGuiaPrestador}}</p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-4">
          <label for="numeroGuiaOperadora">Número Guia da Operadora:</label>
          <p>{{ data.contract?.budget?.guide_number ? data.contract?.budget?.guide_number : '-' }}</p>
        </div>
        <div class="col-lg-4">
          <label for="numeroGuiaSenha">Número Guia/Senha:</label>
          <p>{{ data.contract?.number_process }}</p>
        </div>
        <div class="col-lg-4">
          <label for="dataAutorizacao">Data de Autorização:</label>
          <p>{{ data.contract?.authorization_date | date: 'dd/MM/yyyy' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <label for="obs">Observação</label>
          <p>{{data?.observacao}}</p>
        </div>
      </div>
      <div class="card my-2">
        <div class="card-header">
          <strong>Pacotes</strong>
        </div>
        <div class="table-responsive-vertical">
          <table class="table table-striped" id="table" style="font-size: .85rem;">
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Diárias Previstas</th>
                <th>Diárias Executadas</th>
                <th>Data Execução</th>
                <th>Hora Início</th>
                <th>Hora Fim</th>
                <th>Valor Unit.</th>
                <th>Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor [ngForOf]="data?.medicao_pacotes" let-package>
                <tr>
                  <td>
                    <span class="d-flex align-items-center gap-2">
                      <span>{{ package.package.description | titlecase }}</span>
                      <i
                        class="fas fa-eye text-primary"
                        matTooltip="Visualizar Pacote"
                        (click)="viewPackage(package)"></i>
                    </span>
                  </td>
                  <td>{{ package.budgeted_quantity }}</td>
                  <td>{{ package.quantity }}</td>
                  <td>{{ package.date | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ package.start_hour | date: 'HH:mm' }}</td>
                  <td>{{ package.end_hour | date: 'HH:mm'}}</td>
                  <td>{{ package.value | currency: 'BRL' }}</td>
                  <td>{{ package.subtotal | currency: 'BRL' }}</td>
                </tr>
              </ng-template>
              <tr class="alert alert-info">
                <td colspan="7" class="text-right">
                  TOTAL
                </td>
                <td><b>{{ getTotalPackages() | currency: 'BRL' }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <b>Itens do Orçamento</b>
        </div>
        <div class="table-responsive-vertical">
          <table class="table table-striped" id="table" style="font-size: .85rem;">
            <thead>
              <tr>
                <th>Especialidade</th>
                <th>Qtd Sessão</th>
                <th>Qtd Atendida</th>
                <th *ngIf="!usuario.user.pessoa.cliente">Data Execução</th>
                <th *ngIf="!usuario.user.pessoa.cliente">Hora Inicio</th>
                <th *ngIf="!usuario.user.pessoa.cliente">Hora Fim</th>
                <th *ngIf="!usuario.user.pessoa.cliente">Redução/Acrescimo</th>
                <th>Valor Unitário</th>
                <th>Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of data?.medicao_servicos">
                <td data-title="Serviço">{{ item.servico?.descricao| titlecase }}</td>
                <td data-title="Qtd Sessão">{{ item.quantidade }}</td>
                <td data-title="Qtd Atendida">{{item.atendido}}</td>
                <td data-title="Data Execução" *ngIf="!usuario.user.pessoa.cliente">{{item.dataExecucao | date: "dd/MM/yyyy"}}</td>
                <td data-title="Hora Início" *ngIf="!usuario.user.pessoa.cliente">{{item.horaInicial}}</td>
                <td data-title="Hora Fim" *ngIf="!usuario.user.pessoa.cliente">{{item.horaFinal}}</td>
                <td data-title="Redução/Acrescimo" *ngIf="!usuario.user.pessoa.cliente">{{item.reducaoAcrescimo}}</td>
                <td data-title="Valor Unitário">{{ item.valor | currency: "BRL" }}</td>
                <td data-title="Valor Total">{{ item.subtotal | currency: "BRL" }}</td>
              </tr>
              <tr *ngFor="let item of data?.medicao_produtos">
                <td data-title="Produto">
                  {{ item.ml_products_company?.ml_products_table_versions_prices?.product?.description | titlecase }}
                  <span class="material-icons text-success ml-1"
                    [matTooltip]="
                    item.from_package ? 'Produto de Pacote' :
                      item.from_addition ? 'Produto de Aditivo' :
                        'Produto de Prorrogação'">
                    <i
                      class="bi"
                      *ngIf="item.from_addition || item.from_extension"
                      [class.bi-plus-square-fill]="item.from_addition"
                      [class.bi-arrow-clockwise]="item.from_extension"
                      ></i>
                    <span *ngIf="item.from_package"
                      style="color: #50a592; font-size: .85rem">inventory_2</span>
                  </span>
                </td>
                <td data-title="Qtd Sessão">{{ item.quantidade }}</td>
                <td data-title="Qtd Atendida">{{item.atendido}}</td>
                <td data-title="Data Execução" *ngIf="!usuario.user.pessoa.cliente">{{item.dataExecucao | date: "dd/MM/yyyy"}}</td>
                <td data-title="Hora Início" *ngIf="!usuario.user.pessoa.cliente">{{item.horaInicial}}</td>
                <td data-title="Hora Fim" *ngIf="!usuario.user.pessoa.cliente">{{item.horaFinal}}</td>
                <td data-title="Redução/Acrescimo" *ngIf="!usuario.user.pessoa.cliente">{{item.reducaoAcrescimo}}</td>
                <td data-title="Valor Unitário">{{ item.valor | currency: "BRL" }}</td>
                <td data-title="Valor Total">{{item.subtotal | currency: "BRL"}}</td>
              </tr>
              <tr class="alert alert-info">
                <td colspan="3">Adicional: <strong>{{data.adicional | currency: "BRL"}}</strong></td>
                <td colspan="3">Desconto: <strong>{{data.desconto | currency: "BRL"}}</strong></td>
                <td colspan="3">TOTAL: <strong>{{ data.valor | currency: "BRL" }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <app-comentariosnewmedicao [medicao]="data"></app-comentariosnewmedicao>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" class="btn ml-secondary text-white mx-2" (click)="dialogRef.close()">
      Fechar
    </button>
    <button type="button" (click)="downloadPdf()" class="btn ml-warning text-white">
      <i class="fas fa-file-pdf"></i>
      Exportar PDF
    </button>

  </mat-dialog-actions>
